import axios from 'axios';

const BASE_URL =
    process.env.REACT_APP_API_URL;


export const getModules = async (
    planType,
    businessVertical,
    authToken
) => {
    try {
        const config = {
            params: {
                planType,
                businessVertical,
            },
        };

        if (authToken) {
            config.headers = {
                Authorization: `Bearer ${authToken}`,
            };
        }

        const response = await axios.get(
            `${BASE_URL}/subscription/plans`,
            config
        );

        return response.data;

    } catch (error) {
        console.error(
            "GET Modules Error:",
            error
        );

        throw error;
    }
};

export const fetchSubscriptionPlans = async () => {

    try {

        // Get token from localStorage
        const authToken =
            localStorage.getItem("authToken");


        const response = await axios.get(
            `${BASE_URL}/subscription/api/subscription/plans?planType=STANDARD&businessVertical=FOOD_AND_BEVERAGES`,
            {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    "Content-Type": "application/json",
                },
            }
        );

        return {
            success: true,
            data: response.data,
        };

    } catch (error) {

        console.error(
            "Fetch Subscription Error:",
            error.response || error
        );

        return {
            success: false,
            status: error.response?.status,
            message:
                error.response?.data?.message ||
                error.message,
        };
    }
};

// ===============================
// SAVE / UPDATE MODULES
// ===============================

export const saveModules = async (
    businessVertical,
    planType,
    modules,
    authToken
) => {
    try {
        const config = {
            headers: {
                "Content-Type":
                    "application/json",
            },
        };

        if (authToken) {
            config.headers.Authorization =
                `Bearer ${authToken}`;
        }

        const response = await axios.post(
            `${BASE_URL}/subscription/api/subscription/admin/plans`,
            {
                businessVertical,
                planType,
                modules,
            },
            config
        );

        return response.data;

    } catch (error) {
        console.error(
            "SAVE Modules Error:",
            error
        );

        throw error;
    }
};